<template>
  <div>
    <el-row type="flex" justify="space-between" class="title-bar">
        <div>
          <el-radio-group v-model="tableType" class="mr-r10">
            <el-radio label="standard">기본</el-radio>
            <el-radio label="expand">확장</el-radio>
          </el-radio-group>
        </div>
        <div>
          <el-button size="small"  @click="onClickExportExcel"><img src="@/assets/img/icons/excel.png" style="position:relative;top:3px;left:-2px"> 엑셀출력</el-button>
          <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
        </div>
    </el-row>
    <el-row>
      <el-table-wrapper v-loading="isLoading" ref="netdeviceTable" border :data="tableDatas" :columns="columns" :show-custom-header="true" :show-search-tool="showSearchTool" :show-overflow-tooltip="true"
      :pagination="true" :remote="true" :total="tableTotal" :column-default="columnDefault" @condition-change="onChangeTable">
        <template slot-scope="scope" slot="cpu-slot">
          <w-multiple-rsc-perf-progress-bar v-if="!isNil(scope.row['DEVICE_PERF/CPU_USERATE'])" :perfRecords="scope.row" perfKey="DEVICE_PERF/CPU_USERATE"
          @click-button="onClickMultipleButton(scope.row.objId, scope.row.objName, 'CPU_USERATE')"/>
          <span v-else>{{ EMPTY_TEXT }}</span>
        </template>
        <template slot-scope="scope" slot="memory-slot">
          <w-rsc-perf-event-progress-bar v-if="!isNil(scope.row['DEVICE_PERF/MEM_USERATE'])" :perfRecords="scope.row" perfKey="DEVICE_PERF/MEM_USERATE" />
          <span v-else>{{ EMPTY_TEXT }}</span>
        </template>
        <template slot-scope="scope" slot="icmp-slot">
          <span> {{ convertSlotValue(scope.row['RESPONSETIME/RESPONSETIME_ICMP']) }}</span>
        </template>
        <template slot-scope="scope" slot="snmp-slot">
          <span> {{ convertSlotValue(scope.row['RESPONSETIME/RESPONSETIME_SNMP']) }}</span>
        </template>
        <template slot-scope="scope" slot="temperature-slot">
          <span>{{ convertCValue(scope.row['DEVICE_PERF/DEVICE_TEMP']) }}</span>
          <i v-if="scope.row['DEVICE_PERF/DEVICE_TEMP/MULTIPLE']" class="fas fa-plus"
          @click="onClickMultipleButton(scope.row.objId, scope.row.objName, 'DEVICE_TEMP', scope.row.objCompanyId)" style="cursor:pointer;margin-top:3px;margin-left:4px" />
        </template>
        <template slot-scope="scope" slot="module-status-slot">
          <span> {{ getTableValueAfterCheckEmpty(null, null, scope.row['DEVICE_PERF/MODULE_STATUS']) }}</span>
          <i v-if="scope.row['DEVICE_PERF/MODULE_STATUS/MULTIPLE']" class="fas fa-plus"
          @click="onClickMultipleButton(scope.row.objId, scope.row.objName, 'MODULE_STATUS', scope.row.objCompanyId)" style="cursor:pointer;margin-top:3px;margin-left:4px" />
        </template>
        <template slot-scope="scope" slot="fan-status-slot">
          <span> {{ getTableValueAfterCheckEmpty(null, null, scope.row['DEVICE_PERF/FAN_STATUS']) }}</span>
          <i v-if="scope.row['DEVICE_PERF/FAN_STATUS/MULTIPLE']" class="fas fa-plus"
          @click="onClickMultipleButton(scope.row.objId, scope.row.objName, 'FAN_STATUS', scope.row.objCompanyId)" style="cursor:pointer;margin-top:3px;margin-left:4px" />
        </template>
        <template slot-scope="scope" slot="power-status-slot">
          <span> {{ getTableValueAfterCheckEmpty(null, null, scope.row['DEVICE_PERF/POWER_STATUS']) }}</span>
          <i v-if="scope.row['DEVICE_PERF/POWER_STATUS/MULTIPLE']" class="fas fa-plus"
          @click="onClickMultipleButton(scope.row.objId, scope.row.objName, 'POWER_STATUS', scope.row.objCompanyId)" style="cursor:pointer;margin-top:3px;margin-left:4px" />
        </template>
        <template slot-scope="scope" slot="module-temp-slot">
          <span> {{ convertCValue(scope.row['DEVICE_PERF/MODULE_TEMP']) }}</span>
          <i v-if="scope.row['DEVICE_PERF/MODULE_TEMP/MULTIPLE']" class="fas fa-plus"
          @click="onClickMultipleButton(scope.row.objId, scope.row.objName, 'MODULE_TEMP')" style="cursor:pointer;margin-top:3px;margin-left:4px" />
        </template>
        <template #obj-name-slot="scope">
          <span v-if="scope.row.objName" class="link c-pointer" @click="clickObjName(scope.row)">{{scope.row.objName}}</span>
          <span v-else>-</span>
        </template>
      </el-table-wrapper>
    </el-row>
    <w-multiple-rsc-key-info-popup ref="popup" :config-oid-status-list="configOidStatusList"></w-multiple-rsc-key-info-popup>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { isNil, isEmpty, cloneDeep } from 'lodash';
import { isTrue } from '@/utils/boolean';
import { columnDefault } from '@/constants/table';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { convertValuByUnit, convertValueForInterfaceSpeed } from '@/utils/number';
import commonAPI from '@/api/performance/common';
import FileApi from '@/api/common/file';
import msgUtil from '@/utils/message';
import { routePathByObjId } from '@/utils/router';
import { menuDefine } from '@/constants/menu';
import { performanceNodeTabs } from '@/constants/performance';
import WRscPerfEventProgressBar from '@/components/progressbar/RscPerfEventProgressBar';
import WMultipleRscPerfProgressBar from '@/components/progressbar/MultipleRscPerfProgressBar';
import { customer } from '@/constants/customer-define';
import WMultipleRscKeyInfoPopup from '../popup/MultipleRscKeyInfoPopup';

export default {
  name: 'WNetdevicePerfTable',
  components: {
    WRscPerfEventProgressBar,
    WMultipleRscPerfProgressBar,
    WMultipleRscKeyInfoPopup,
  },
  props: {
    active: {
      type: Boolean,
      defulat: () => false,
    },
  },
  data() {
    return {
      customer,
      isLoading: false,
      tableType: 'standard',
      tableDatas: [],
      columnDefault,
      tableTotal: 0,
      showSearchTool: false,
      columns: [],
      // 공통컬럼
      commonColumns: [
        { prop: 'objName', label: '장비명', scopedSlot: 'obj-name-slot', headerAlign: 'center', sortable: true, searchable: true, remoteProp: 'o.obj_name', formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'ipaddress', label: 'IP', headerAlign: 'center', sortable: true, searchable: true, width: 120, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'objtypeName', label: '장비종류', headerAlign: 'center', sortable: true, searchable: true, remoteProp: 'ot.objtype_name', width: 120, formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'objCompanyName', label: '벤더', headerAlign: 'center', sortable: true, searchable: true, width: 120, remoteProp: 'oc.obj_company_name', formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'objProductId', label: '모델명', headerAlign: 'center', sortable: true, searchable: true, remoteProp: 'o.obj_product_id', formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'DEVICE_PERF/CPU_USERATE', sortable: true, label: 'CPU', headerAlign: 'center', width: 150, scopedSlot: 'cpu-slot' },
        { prop: 'DEVICE_PERF/MEM_USERATE', sortable: true, label: '메모리', scopedSlot: 'memory-slot', headerAlign: 'center', width: 150 },
        { prop: 'DEVICE_PERF/DEVICE_TEMP', sortable: true, label: '온도', scopedSlot: 'temperature-slot', headerAlign: 'center', width: 90 },
      ],
      // 확장용
      expandColumns: [
        { prop: 'DEVICE_PERF/MODULE_STATUS', sortable: true, label: '모듈상태', scopedSlot: 'module-status-slot', headerAlign: 'center', width: 90 },
        { prop: 'DEVICE_PERF/MODULE_TEMP', sortable: true, label: '모듈온도', scopedSlot: 'module-temp-slot', headerAlign: 'center', width: 90 },
        { prop: 'DEVICE_PERF/FAN_STATUS', sortable: true, label: '팬상태', scopedSlot: 'fan-status-slot', headerAlign: 'center', width: 90 },
        { prop: 'DEVICE_PERF/POWER_STATUS', sortable: true, label: '파워상태', scopedSlot: 'power-status-slot', headerAlign: 'center', width: 90 },
        { prop: 'DEVICE_PERF/CPS', sortable: true, unit: 'cps', label: '초당 세션수', headerAlign: 'center', width: 90, formatter: this.convertUnitValue },
        { prop: 'DEVICE_PERF/SESSION', sortable: true, unit: 'count', label: '세션수', headerAlign: 'center', width: 90, formatter: this.convertUnitValue },
      ],
      // 트래픽
      trafficColumn: {
        label: '트래픽 (bps)',
        headerAlign: 'center',
        childColumns: [
          { prop: 'DEVICE_TRAFFIC/TRAFFIC_BPS_IN', sortable: true, label: 'IN', headerAlign: 'center', width: 100, formatter: this.convertValue },
          { prop: 'DEVICE_TRAFFIC/TRAFFIC_BPS_OUT', sortable: true, label: 'OUT', headerAlign: 'center', width: 100, formatter: this.convertValue },
        ],
      },
      responseColumn: {
        label: '응답시간 (ms)',
        headerAlign: 'center',
        childColumns: [
          { prop: 'RESPONSETIME/RESPONSETIME_ICMP', sortable: true, label: 'ICMP', headerAlign: 'center', width: 100, scopedSlot: 'icmp-slot' },
          { prop: 'RESPONSETIME/RESPONSETIME_SNMP', sortable: true, label: 'SNMP', headerAlign: 'center', width: 100, scopedSlot: 'snmp-slot' },
        ],
      },
      // 고객사 - SK
      customerColumn: {
        prop: 'skccCustomerName', remoteProp: 'sc.customer_name', label: '고객사', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty, customerId: 'SKCC',
      },
      EMPTY_TEXT,
      configOidStatusList: {},
    };
  },
  computed: {
    customerId() {
      return this.$store.state.common.customerId;
    },
    ...mapGetters(['selectedNode', 'selectedObjDefineIds', 'selectedObjDefineIdsForPhysical']),
  },
  watch: {
    selectedNode: {
      handler() {
        if (this.$refs.netdeviceTable === undefined) {
          this.$nextTick(() => {
            this.$refs.netdeviceTable.clearFilter(); // 선택한 노드 변경할 때마다 기존 필터링 정보를 초기화
            this.loadStore();
          });
        } else {
          this.$refs.netdeviceTable.clearFilter(); // 선택한 노드 변경할 때마다 기존 필터링 정보를 초기화
          this.loadStore();
        }
      },
      // immediate: true,
    },
    selectedObjDefineIdsForPhysical: {
      handler() {
        this.loadStore();
      },
    },
    selectedObjDefineIds: {
      handler() {
        this.loadStore();
      },
    },
    active: {
      handler() {
        this.loadStore();
      },
    },
    /**
     * 애플망고 SKCC - 기본/확장 라디오 버튼에 제공 - 기본 컬럼의 경우 트래픽 포함, 확장의 경우 제외
     * @author Song
     */
    tableType: {
      handler(value) {
        this.columns = [];
        this.$nextTick(() => {
          // 테이블 컬럼을 변경하면서 기존 필터링 정보를 초기화한다.
          this.$refs.netdeviceTable.clearFilter();
          this.columns = value === 'standard' ?
            [...cloneDeep(this.commonColumns), cloneDeep(this.responseColumn), cloneDeep(this.trafficColumn)] :
            [...cloneDeep(this.commonColumns), ...cloneDeep(this.expandColumns)];
          if (value === 'expand' && (this.customerId === this.customer.SKCC || this.customerId === this.customer.SKT)) {
            this.columns.splice(0, 0, cloneDeep(this.customerColumn));
          }
          this.loadStore();
        });
      },
      immediate: true,
    },
  },
  methods: {
    isNil,
    /**
     * 기존 loadStore > SKCC - 성능정보인 모듈상태에 대한 치환값(벤더 기준, 구성 OID)도 조회한다.
     * @author Song
     * @param  {Object} row
     * @param  {Object} column
     * @param  {String/Number} valu
     */
    loadStore() {
      if (this.active) {
        this.isLoading = true;
        const treeType = this.$route.path.indexOf('physical') > 0 ? 'physical' : 'logical';
        const tableParams = this.$refs.netdeviceTable.getParameter();
        const params = {
          managegroupIds: this.selectedNode.childManagegroupIds,
          managetypeId: 'NMS',
          objDefineIds: this.selectedObjDefineIds,
          treeType,
          objCompanyId: this.selectedNode.objCompanyId,
          customerId: this.tableType === 'expand' ? this.customerId : null,
          tableType: this.tableType,
          ...tableParams,
        };
        if (!isEmpty(this.selectedObjDefineIdsForPhysical)) {
          params.objCompanyIds = this.selectedObjDefineIdsForPhysical;
        }
        commonAPI.getPerformanceGroupList(params).then((result) => {
          if (result.data.success) {
            this.tableDatas = result.data.data;
            this.tableTotal = result.data.total;
          }
        }).catch(() => {}).finally(() => {
          this.isLoading = false;
        });
      }
    },
    /**
     * 테이블 데이터 빈값 확인
     * @author Yang
     * @param  {Object} row
     * @param  {Object} column
     * @param  {String/Number} valu
     */
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * [getStringtoNumber String형 Number형으로 변경]
     * @author {Yang}
     */
    getStringtoNumber(value) {
      return Number(value);
    },
    /**
     * [테이블 컬럼 포멧]
     * @author {Yang}
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    convertValue(row, column, value) {
      return isNil(value) ? EMPTY_TEXT : convertValueForInterfaceSpeed(value);
    },
    convertCValue(value) {
      return isNil(value) ? EMPTY_TEXT : convertValuByUnit(value, '℃', false);
    },
    convertSlotValue(value) {
      return isNil(value) ? EMPTY_TEXT : convertValuByUnit(value, null);
    },
    convertUnitValue(row, column, value) {
      return isNil(value) ? EMPTY_TEXT : convertValuByUnit(value, column.unit);
    },
    onChangeTable() {
      this.loadStore();
    },
    onClickMultipleButton(objId, objName, rscId, objCompanyId) {
      this.$refs.popup.open(objId, objName, rscId, objCompanyId);
    },
    /**
     * 장비명 클릭 시 성능/운영 > 요약 탭으로 이동한다. [애플망고 SK]
     * @author Song
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    clickObjName(row) {
      if (!isNil(row.objId)) {
        routePathByObjId(this, row.objId, menuDefine.PERF_OPER, performanceNodeTabs.summary.name, isEmpty(this.selectedNode) ? undefined : this.selectedNode.childManagegroupIds, null, false);
      }
    },
    convertStatusBoolean(data) {
      if (EMPTY_TEXT !== data) {
        return isTrue(data) ? 'UP' : 'DOWN';
      }
      return data;
    },
    /**
     * 그리드 데이터 엑셀출력
     * @author NaJY
     * @return {[type]}         [description]
     */
    onClickExportExcel() {
      const treeType = this.$route.path.indexOf('physical') > 0 ? 'physical' : 'logical';
      const tableParams = this.$refs.netdeviceTable.getParameter();
      const params = {
        managegroupIds: this.selectedNode.childManagegroupIds,
        managetypeId: 'NMS',
        objDefineIds: this.selectedObjDefineIds,
        treeType,
        objCompanyId: this.selectedNode.objCompanyId,
        customerId: this.tableType === 'expand' ? this.customerId : null,
        tableType: this.tableType,
        ...tableParams,
      };
      if (!isEmpty(this.selectedObjDefineIdsForPhysical)) {
        params.objCompanyIds = this.selectedObjDefineIdsForPhysical;
      }

      commonAPI.exportNetdeviceGroupPerfInfo(params)
        .then((response) => {
          if (response.data.success && !isNil(response.data.data)) {
            FileApi.downloadExportedExcelFile(response.data.data);
          } else {
            this.$message(msgUtil.getResultMsgData('출력', '엑셀', false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData('출력', '엑셀', false));
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/group/perfinfo/components/NetdevicePerfTable.vue